export default {
  vertical: 'vertical',
  horizontal: 'horizontal',
};
